{
  "codexEntityForm": {
    "character": "Postać",
    "place": "Miejsce",
    "faction": "Frakcja",
    "object": "Przedmiot",
    "concept": "Pojęcie",
    "editName": "Edytuj: {{name}}",
    "newCodexEntry": "Nowy wpis Kodeksu",
    "theWorldHasChangedTheDraft": "Świat się zmienił. Wersja robocza jest zachowana; wczytaj wpis ponownie przed zapisem.",
    "portraitChooseAnImage": "Portret: wybierz obraz",
    "change": "Zmień",
    "addPortrait": "Dodaj portret",
    "portraitImage": "Obraz portretu",
    "entryName": "Nazwa wpisu",
    "name": "Nazwa",
    "entryType": "Typ wpisu",
    "customCategory": "Własna kategoria",
    "categoryEGDeityShipSpell": "Kategoria, np. Bóstwo, Statek, Zaklęcie",
    "aliases": "Aliasy",
    "entryAliases": "Aliasy wpisu",
    "otherNamesOneAtATime": "Inne nazwy, po jednej…",
    "tags": "Tagi",
    "entryTags": "Tagi wpisu",
    "themesRolesArcs": "Motywy, role, łuki…",
    "collection": "Kolekcja",
    "entryCollection": "Kolekcja wpisu",
    "noCustomCollection": "Brak własnej kolekcji",
    "folder": "Folder",
    "entryFolder": "Folder wpisu",
    "unfiled": "Bez folderu",
    "notes": "Notatki",
    "entryNotes": "Notatki wpisu",
    "whoTheyAreWhatTheyWant": "Kim są, czego chcą, czego czytelnik nie może poznać za wcześnie…",
    "entryFields": "Pola wpisu",
    "fields": "Pola",
    "fieldTemplate": "Szablon pól",
    "template": "Szablon…",
    "schemaOf": "Schemat:",
    "addMissingFields": "Dodaj brakujące pola",
    "addField": "Dodaj pole",
    "noCustomFieldYetFieldsGive": "Brak własnych pól. Pola dają wpisowi ustrukturyzowane fakty — wiek, lojalność, sekret — o których Kontrole mogą wnioskować.",
    "sharedFieldNamesTypesAndOptions": "Wspólne nazwy, typy i opcje pól zarządza się w ustawieniach kolekcji. Wartości należą do tej strony.",
    "fieldNameN": "Nazwa pola {{n}}",
    "fieldName": "Nazwa pola",
    "fieldTypeN": "Typ pola {{n}}",
    "unknown": "Nieznany",
    "fieldValueN": "Wartość pola {{n}}",
    "select": "Wybierz…",
    "yes": "Tak",
    "no": "Nie",
    "value": "Wartość",
    "chooseAnEntry": "Wybierz wpis…",
    "eGSpringOfYear12": "np. wiosna roku 12 albo dzień oblężenia",
    "below": "Poniżej",
    "unknownValueN": "Nieznana wartość {{n}}",
    "required": "Wymagane",
    "sharedField": "Pole wspólne",
    "remove": "Usuń",
    "confirmRemoval": "Potwierdź usunięcie",
    "paragraph": "Akapit",
    "aFewLines": "Kilka linijek…",
    "discardTheDraft": "Odrzucić wersję roboczą?",
    "confirmReload": "Potwierdź ponowne wczytanie",
    "keepEditing": "Kontynuuj edycję",
    "reloadEntry": "Wczytaj wpis ponownie",
    "cancel": "Anuluj",
    "chooseAnImageFileForThe": "Wybierz plik obrazu dla portretu.",
    "thePortraitMustBeUnder8": "Portret musi mieć mniej niż 8 MiB.",
    "saveEntry": "Zapisz wpis",
    "searchEntries": "Szukaj wpisów…"
  },
  "codexEntryDialog": {
    "newCodexEntry": "Nowy wpis Kodeksu",
    "savedToWorldCodexTheManuscript": "Zapisano w Świat › Kodeks; rękopis wspomni o nim w miejscu, w którym pisano.",
    "createAndMention": "Utwórz i wspomnij"
  },
  "continuityPanel": {
    "relationsOverTime": "Relacje w czasie",
    "checkingRelations": "Sprawdzanie relacji…",
    "cancel": "Anuluj",
    "theProjectHasChangedRunThe": "Rękopis lub świat zmienił się od tego uruchomienia. Uruchom kontrole ponownie, aby odświeżyć relacje.",
    "anAnalysisLimitWasReachedThe": "Osiągnięto limit analizy. Wynik jest częściowy.",
    "ruleApplied": "Reguła: „{{label}}”, {{rule}}.",
    "oneSourcePerTarget": "jedno źródło dla każdego celu",
    "oneTargetPerSource": "jeden cel dla każdego źródła",
    "interval": "od {{start}} do {{end}}",
    "openScene": "Otwórz: {{scene}}",
    "findingReferenceMissing": "Wskazuje wpis, który już nie istnieje.",
    "findingConfirmedWithoutEvidence": "Potwierdzone bez cytatu z tekstu, więc jego źródła nie da się sprawdzić.",
    "findingEvidenceMissing": "Cytat, na którym się opiera, zniknął.",
    "findingEvidenceNotCurrent": "Cytat, na którym się opiera, nie jest potwierdzony albo nie pasuje już do tekstu.",
    "findingExclusiveNotEvaluable": "Nie można sprawdzić względem reguły: potrzebny jest kierunek, oba końce i pełny przedział czasu.",
    "findingExclusiveOverlap": "Dwie z nich obowiązują w tym samym czasie, czego reguła nie dopuszcza.",
    "findingOther": "Coś do sprawdzenia w tej relacji.",
    "theProjectExceedsTheLimitOf": "Projekt przekracza limit tej analizy. Żadne dane nie zostały zmienione.",
    "theAnalysisExceededItsExecutionLimit": "Analiza przekroczyła limit wykonania. Żadne dane nie zostały zmienione.",
    "analysisCancelled": "Analiza anulowana.",
    "checksNotCompletedTheTextAnd": "Kontrole nieukończone. Tekst i kanon nie zostały zmienione."
  },
  "eventTimelinePanel": {
    "eventHistory": "Historia wydarzeń",
    "timeline": "Oś czasu",
    "newEvent": "Nowe wydarzenie",
    "searchEvents": "Szukaj wydarzeń",
    "searchEvents2": "Szukaj wydarzeń…",
    "timelineOrder": "Kolejność osi czasu",
    "storyTime": "Czas historii",
    "readingOrder": "Kolejność czytania",
    "dateStatus": "Status daty",
    "allDates": "Wszystkie daty",
    "resolvedDates": "Daty ustalone",
    "unresolvedDates": "Daty nieustalone",
    "filterEventsByScene": "Filtruj wydarzenia według sceny",
    "allScenes": "Wszystkie sceny",
    "scenes": "Sceny",
    "editEvent": "Edytuj wydarzenie",
    "closeEventEditor": "Zamknij edytor wydarzenia",
    "theWorldHasChangedReloadThe": "Świat się zmienił. Wczytaj wydarzenie ponownie przed zapisem; pola wersji roboczej są zachowane.",
    "eventTitle": "Tytuł wydarzenia",
    "whatHappens": "Co się dzieje",
    "scene": "Scena",
    "eventScene": "Scena wydarzenia",
    "notLinked": "Niepowiązane",
    "removedSceneSceneid": "Usunięta scena — {{sceneId}}",
    "dateType": "Typ daty",
    "eventDateType": "Typ daty wydarzenia",
    "unknown": "Nieznana",
    "definedInterval": "Zdefiniowany przedział",
    "relativeToAnEvent": "Względem wydarzenia",
    "start": "Początek",
    "eventStart": "Początek wydarzenia",
    "endExclusive": "Koniec (wyłączny)",
    "eventEnd": "Koniec wydarzenia",
    "referenceEvent": "Wydarzenie odniesienia",
    "select": "Wybierz…",
    "referenceToVerifyAnchoreventid": "Odniesienie do sprawdzenia — {{anchorEventId}}",
    "events": "Wydarzenia",
    "offsetInTicks": "Przesunięcie w taktach",
    "eventOffset": "Przesunięcie wydarzenia",
    "saveEvent": "Zapisz wydarzenie",
    "closeReload": "Zamknij / wczytaj ponownie…",
    "discardTheDraftChanges": "Odrzucić zmiany w wersji roboczej?",
    "discardDraft": "Odrzuć wersję roboczą",
    "reloadEvent": "Wczytaj wydarzenie ponownie",
    "keepEditing": "Kontynuuj edycję",
    "noEventMatchesTheseFiltersEvents": "Żadne wydarzenie nie pasuje do tych filtrów. Wydarzenia to to, o czym wnioskują Kontrole: kiedy coś się stało i w której scenie czytelnik się o tym dowiaduje.",
    "tickStart": "Takt {{start}}",
    "openScene": "Otwórz scenę",
    "editTitle": "Edytuj: {{title}}",
    "removeTitle": "Usuń: {{title}}",
    "confirmEventRemoval": "Potwierdź usunięcie wydarzenia",
    "cancel": "Anuluj",
    "theWorldHasChangedCancelAnd": "Świat się zmienił: anuluj i otwórz potwierdzenie ponownie.",
    "resolvedDate": "Data ustalona",
    "unknownDate": "Data nieznana",
    "missingReference": "Brakujące odniesienie",
    "timeCycle": "Cykl czasu",
    "dateOutOfRange": "Data poza zakresem",
    "eventsFoundOfTotal_one": "Znaleziono {{count}} wydarzenie · łącznie {{total}}",
    "eventsFoundOfTotal_few": "Znaleziono {{count}} wydarzenia · łącznie {{total}}",
    "eventsFoundOfTotal_many": "Znaleziono {{count}} wydarzeń · łącznie {{total}}",
    "eventsFoundOfTotal_other": "Znaleziono {{count}} wydarzenia · łącznie {{total}}",
    "removeThisEventReferences_one": "Usunąć to wydarzenie? {{count}} bezpośrednie odniesienie będzie wymagać przeglądu.",
    "removeThisEventReferences_few": "Usunąć to wydarzenie? {{count}} bezpośrednie odniesienia będą wymagać przeglądu.",
    "removeThisEventReferences_many": "Usunąć to wydarzenie? {{count}} bezpośrednich odniesień będzie wymagać przeglądu.",
    "removeThisEventReferences_other": "Usunąć to wydarzenie? {{count}} bezpośredniego odniesienia będzie wymagać przeglądu.",
    "showMoreEvents_one": "Pokaż jeszcze {{count}} wydarzenie",
    "showMoreEvents_few": "Pokaż jeszcze {{count}} wydarzenia",
    "showMoreEvents_many": "Pokaż jeszcze {{count}} wydarzeń",
    "showMoreEvents_other": "Pokaż jeszcze {{count}} wydarzenia"
  },
  "fieldEditor": {
    "choose": "Wybierz…",
    "labelSearch": "Szukaj: {{label}}",
    "search": "Szukaj…",
    "labelOptions": "Opcje: {{label}}",
    "noMatch": "Brak wyników.",
    "optionsOnePerLine": "Opcje, po jednej w wierszu",
    "fieldOptionsIndex": "Opcje pola {{index}}",
    "addOptionIndex": "Dodaj opcję {{index}}",
    "newOption": "Nowa opcja",
    "addOption": "Dodaj opcję",
    "fieldValueIndex": "Wartość pola {{index}}",
    "chooseOptions": "Wybierz opcje…",
    "chooseEntries": "Wybierz wpisy…",
    "unsupportedMultiValueEditor": "Nieobsługiwany edytor wielu wartości"
  },
  "graphExplorer": {
    "relationGraph": "Graf relacji",
    "entry": "Wpis",
    "filterGraphByEntry": "Filtruj graf według wpisu",
    "all": "Wszystkie",
    "status": "Status",
    "graphRelationStatus": "Status relacji w grafie",
    "proposedAndConfirmed": "Proponowane i potwierdzone",
    "confirmed": "Potwierdzone",
    "proposed": "Proponowane",
    "relation": "Relacja",
    "searchRelationInTheGraph": "Szukaj relacji w grafie",
    "filterAtStoryTime": "Filtruj według czasu historii",
    "tick": "Takt",
    "graphTick": "Takt grafu",
    "includeUnknownTime": "Uwzględnij nieznany czas",
    "enterANumericTickOrTurn": "Wpisz liczbowy takt albo wyłącz filtr czasu.",
    "navigableRelationGraph": "Nawigowalny graf relacji",
    "selectName": "Zaznacz: {{name}}",
    "entryCount_one": "{{count}} wpis",
    "entryCount_few": "{{count}} wpisy",
    "entryCount_many": "{{count}} wpisów",
    "entryCount_other": "{{count}} wpisu",
    "relationCount_one": "{{count}} relacja",
    "relationCount_few": "{{count}} relacje",
    "relationCount_many": "{{count}} relacji",
    "relationCount_other": "{{count}} relacji",
    "hiddenBeyondViewLimit": "Poza limitem widoku: {{entries}} i {{relations}}.",
    "relationsWithMissingEntries_one": "{{count}} relacja z brakującymi wpisami.",
    "relationsWithMissingEntries_few": "{{count}} relacje z brakującymi wpisami.",
    "relationsWithMissingEntries_many": "{{count}} relacji z brakującymi wpisami.",
    "relationsWithMissingEntries_other": "{{count}} relacji z brakującymi wpisami.",
    "unknownDurationIncluded_one": "Relacje o nieznanym czasie trwania uwzględnione w filtrze: {{count}}.",
    "unknownDurationIncluded_few": "Relacje o nieznanym czasie trwania uwzględnione w filtrze: {{count}}.",
    "unknownDurationIncluded_many": "Relacje o nieznanym czasie trwania uwzględnione w filtrze: {{count}}.",
    "unknownDurationIncluded_other": "Relacje o nieznanym czasie trwania uwzględnione w filtrze: {{count}}.",
    "unknownDurationExcluded_one": "Relacje o nieznanym czasie trwania wykluczone z filtra: {{count}}.",
    "unknownDurationExcluded_few": "Relacje o nieznanym czasie trwania wykluczone z filtra: {{count}}.",
    "unknownDurationExcluded_many": "Relacje o nieznanym czasie trwania wykluczone z filtra: {{count}}.",
    "unknownDurationExcluded_other": "Relacje o nieznanym czasie trwania wykluczone z filtra: {{count}}."
  },
  "relationshipPanel": {
    "select": "Wybierz…",
    "removedReference": "Usunięte odniesienie:",
    "projectRelations": "Relacje projektu",
    "relationsOf": "Relacje:",
    "filterRelationsByEntry": "Filtruj relacje według wpisu",
    "allEntries": "Wszystkie wpisy",
    "searchEntries": "Szukaj wpisów…",
    "searchRelations": "Szukaj relacji",
    "relationOrEntry": "Relacja lub wpis",
    "newRelation": "Nowa relacja",
    "editRelation": "Edytuj relację",
    "relationsLinkTwoEntries": "Relacje łączą dwa wpisy",
    "addTwoEntriesInTheCodex": "Dodaj co najmniej dwa wpisy w Kodeksie, potem napisz słowa, które je łączą, jak „jest mentorem”.",
    "theWorldHasChangedTheFields": "Świat zmienił się, gdy to było otwarte. Twoje pola są zachowane; wczytaj ponownie, aby zapisać na nowych danych.",
    "reload": "Wczytaj ponownie",
    "anEntry": "Wpis",
    "anotherEntry": "Inny wpis",
    "relationSource": "Źródło relacji",
    "relationType": "Typ relacji",
    "isTheMentorOf": "jest mentorem",
    "relationTarget": "Cel relacji",
    "direction": "Kierunek",
    "relationDirection": "Kierunek relacji",
    "oneWay": "W jedną stronę",
    "bothWays": "W obie strony",
    "when": "Kiedy",
    "relationTime": "Czas relacji",
    "notSet": "Nieustawione",
    "betweenTwoMoments": "Między dwoma momentami",
    "fromAnEvent": "Od wydarzenia",
    "from": "Od",
    "to": "do",
    "relationStart": "Początek relacji",
    "relationEnd": "Koniec relacji",
    "momentsHint": "Momenty na osi czasu świata; koniec nie jest wliczony.",
    "event": "Wydarzenie",
    "relationEvent": "Wydarzenie relacji",
    "offset": "Przesunięcie",
    "relationOffset": "Przesunięcie relacji",
    "offsetHint": "Momenty po wydarzeniu; wartość ujemna oznacza czas przed nim.",
    "status": "Status",
    "relationStatus": "Status relacji",
    "proposed": "Proponowana",
    "confirmed": "Potwierdzona",
    "rejected": "Odrzucona",
    "superseded": "Zastąpiona",
    "confirmedRelationsCountAsCanonIn": "Potwierdzone relacje liczą się jako kanon w Kontrolach.",
    "notes": "Notatki",
    "relationNotes": "Notatki relacji",
    "howTheStoryShowsItAnd": "Jak historia to pokazuje i co pozostaje niejednoznaczne.",
    "quotes": "Cytaty",
    "linkQuotes": "Powiąż cytaty z tekstu",
    "quotesLinked": "Cytaty: {{count}}",
    "searchQuotations": "Szukaj cytatów",
    "excerptOrNote": "Fragment lub notatka",
    "removedQuotation": "Usunięty cytat:",
    "noQuotationYetAnnotateAPassage": "Brak cytatu. Zaznacz fragment w rękopisie, aby go tu zacytować.",
    "upTo100QuotationsShownUse": "Pokazano do 100 cytatów. Użyj wyszukiwania, aby zawęzić listę.",
    "saveRelation": "Zapisz relację",
    "cancel": "Anuluj",
    "aDeletedEntry": "usunięty wpis",
    "aDeletedEvent": "usunięte wydarzenie",
    "timeBetween": "Od {{start}} do {{end}}",
    "timeAtEvent": "Przy: {{event}}",
    "timeAfterEvent": "{{event}} + {{offset}}",
    "timeBeforeEvent": "{{event}} − {{offset}}",
    "noRelationsYet": "Brak relacji.",
    "noRelationMatches": "Żadna relacja nie pasuje.",
    "edit": "Edytuj",
    "editCaption": "Edytuj: {{caption}}",
    "remove": "Usuń",
    "removeCaption": "Usuń: {{caption}}",
    "removeThisRelationTheChangeStays": "Usunąć tę relację? Zmiana zostaje w historii.",
    "confirmRemoval": "Usuń",
    "shownOfTotal": "Pokazano 100 z {{total}} relacji. Zawęź wyszukiwanie, aby zobaczyć pozostałe.",
    "theWorldHasChangedReloadThe": "Świat się zmienił. Wczytaj relację ponownie przed zapisem.",
    "theRelationWasChangedOrRemoved": "Relację zmieniono lub usunięto. Wczytaj dane ponownie.",
    "explicitlyConfirmTheRelationBeforeSaving": "Wybierz Potwierdzona ponownie, aby uczynić tę relację kanonem.",
    "selectTwoEntriesThatExistIn": "Wybierz dwa wpisy istniejące w Kodeksie.",
    "fillInTheTimeValuesOr": "Wypełnij momenty albo wybierz Nieustawione.",
    "enterAValidIntervalTheEnd": "Koniec musi być po początku.",
    "selectAnExistingEventAsThe": "Wybierz wydarzenie, które nadal istnieje.",
    "theSelectedQuotationIsNoLonger": "Wybrany cytat już nie istnieje.",
    "checkTheRelationTextAndThe": "Sprawdź słowa relacji i notatki.",
    "theChangeWasNotSavedReload": "Zmiana nie została zapisana. Wczytaj dane ponownie i spróbuj jeszcze raz."
  },
  "useWorldReplication": {
    "signInToTheLinkedAccount": "Zaloguj się na połączone konto i sprawdź swój dostęp do tego projektu. Twoje lokalne zmiany są zachowane.",
    "syncTheManuscriptWithThisServer": "Zsynchronizuj rękopis z tym serwerem przed połączeniem jego Świata.",
    "theWorldChangedAfterTheComparison": "Świat zmienił się po porównaniu. Przejrzyj aktualne kopie ponownie.",
    "aConfirmationOrRestoredRecordNeeds": "Potwierdzenie lub przywrócony zapis wymaga jawnego przeglądu, zanim będzie można go zsynchronizować.",
    "anAttachmentOrRemoteCopyFailed": "Załącznik lub zdalna kopia nie przeszły weryfikacji. Twój lokalny Świat jest zachowany.",
    "theseChangesExceedASyncLimit": "Te zmiany przekraczają limit synchronizacji albo muszą być zastosowane razem. Twój lokalny Świat i oczekujące zmiany są zachowane.",
    "syncPausedYourLocalChangesAre": "Synchronizacja wstrzymana. Twoje lokalne zmiany są zachowane.",
    "newMapNeedsPlan": "Nowe mapy są dostępne w planach Ink i Press. Mapa zostaje na tym urządzeniu, a Świat czeka: usuń nową mapę albo wybierz plan, aby zsynchronizować ją ponownie.",
    "worldSyncCouldNotFinishCheck": "Synchronizacja Świata nie została ukończona. Sprawdź połączenie i spróbuj ponownie. Twoje lokalne zmiany są zachowane."
  },
  "vaultFolders": {
    "folderName": "Folder: {{name}}",
    "editFolder": "Edytuj folder",
    "newSubfolder": "Nowy podfolder",
    "moveContentsBeforeRemoving": "Przenieś zawartość przed usunięciem",
    "removeFolder": "Usuń folder",
    "folderActionsName": "Działania folderu: {{name}}",
    "chooseThisFolderWhenEditingA": "Wybierz ten folder, edytując stronę.",
    "projectFolders": "Foldery projektu",
    "folders": "Foldery",
    "newFolder": "Nowy folder",
    "groupPagesFromAnyCollection": "Grupuj strony z dowolnej kolekcji.",
    "foldersOrganizePagesWithoutChangingTheir": "Foldery porządkują strony bez zmiany ich kolekcji ani zawartości.",
    "cancel": "Anuluj",
    "saveFolder": "Zapisz folder",
    "name": "Nazwa",
    "folderName2": "Nazwa folderu",
    "inside": "Wewnątrz",
    "parentFolder": "Folder nadrzędny",
    "projectRoot": "Katalog główny projektu",
    "removeEmptyFolder": "Usunąć pusty folder?",
    "removeNameFromTheProject": "Usunąć „{{name}}” z projektu?"
  },
  "vaultTable": {
    "unavailableEntry": "Niedostępny wpis",
    "vaultTable": "Tabela Archiwum",
    "pages": "Strony",
    "searchVaultTable": "Przeszukaj tabelę Archiwum",
    "searchPages": "Szukaj stron…",
    "tableCollection": "Kolekcja tabeli",
    "allCollections": "Wszystkie kolekcje",
    "noCustomCollection": "Brak własnej kolekcji",
    "tableFolder": "Folder tabeli",
    "allFolders": "Wszystkie foldery",
    "unfiled": "Bez folderu",
    "scrollableVaultTable": "Przewijalna tabela Archiwum",
    "name": "Nazwa",
    "collection": "Kolekcja",
    "folder": "Folder",
    "noPagesMatchTheseFilters": "Żadna strona nie pasuje do tych filtrów.",
    "none": "Brak",
    "yes": "Tak",
    "no": "Nie",
    "pagesShown_one": "Strony: {{shown}} z {{count}}",
    "pagesShown_few": "Strony: {{shown}} z {{count}}",
    "pagesShown_many": "Strony: {{shown}} z {{count}}",
    "pagesShown_other": "Strony: {{shown}} z {{count}}"
  },
  "vaultTree": {
    "blue": "Niebieski",
    "emerald": "Szmaragd",
    "gold": "Złoty",
    "violet": "Fioletowy",
    "rose": "Różowy",
    "amber": "Bursztynowy",
    "teal": "Morski",
    "slate": "Łupkowy",
    "crimson": "Karmazynowy",
    "bark": "Kora",
    "forest": "Leśny",
    "navy": "Granatowy",
    "orchid": "Orchidea",
    "saffron": "Szafranowy",
    "ink": "Atrament",
    "ember": "Żar",
    "concept": "Pojęcie",
    "character": "Postać",
    "place": "Miejsce",
    "faction": "Frakcja",
    "object": "Przedmiot",
    "vault": "Archiwum",
    "newCollection": "Nowa kolekcja",
    "vaultView": "Widok Archiwum",
    "pages": "Strony",
    "table": "Tabela",
    "pagesMarkedUnassignedKeepTheirPrevious": "Strony oznaczone jako nieprzypisane zachowują poprzednie pola. Edytuj stronę, aby wybrać jej kolekcję.",
    "filterPages": "Filtruj strony",
    "filterPages2": "Filtruj strony…",
    "worldVault": "Archiwum świata",
    "removeCollectionName": "Usuń kolekcję {{name}}",
    "collectionSettingsForName": "Ustawienia kolekcji {{name}}",
    "iconAndColour": "Ikona i kolor",
    "newPageInName": "Nowa strona w: {{name}}",
    "noPageYetAddTheFirst": "Brak stron — dodaj pierwszą przyciskiem +.",
    "nothingHereYet": "Nic tu jeszcze nie ma.",
    "removeEmptyCollection": "Usunąć pustą kolekcję?",
    "removeNameAndItsSchema": "Usunąć „{{name}}” i jej schemat?",
    "removeCollection": "Usuń kolekcję",
    "text": "Tekst",
    "theSvgMustBeUnder16": "SVG musi mieć mniej niż 16 KiB.",
    "thisFileIsNotAUsable": "Ten plik nie jest użytecznym SVG (skrypty i zewnętrzne odniesienia są usuwane; korzeniem musi być <svg>).",
    "collectionName": "Kolekcja: {{name}}",
    "sharedFieldsApplyToEveryPage": "Pola wspólne dotyczą każdej strony tej kolekcji. Każda strona może też mieć własne pola.",
    "cancel": "Anuluj",
    "saving": "Zapisywanie…",
    "saveCollection": "Zapisz kolekcję",
    "createCollection": "Utwórz kolekcję",
    "identity": "Tożsamość",
    "nameAndIconAsTheTree": "Nazwa i ikona, tak jak pokażą je drzewo i strony.",
    "name": "Nazwa",
    "collectionName2": "Nazwa kolekcji",
    "magic": "Magia",
    "aCollectionWithThisNameAlready": "Kolekcja o tej nazwie już istnieje.",
    "icon": "Ikona",
    "iconSource": "Źródło ikony",
    "lucide181": "Lucide (181)",
    "yourSvg": "Twoje SVG",
    "collectionIcon": "Ikona kolekcji",
    "searchLucideIcons": "Szukaj ikon Lucide",
    "searchIconsCastleSwordMoon": "Szukaj ikon — zamek, miecz, księżyc…",
    "loadingIcons": "Wczytywanie ikon…",
    "lucideIcon": "Ikona Lucide",
    "noIconMatches": "Żadna ikona nie pasuje.",
    "chooseAnSvgFile": "Wybierz plik SVG",
    "customSvgIcon": "Własna ikona SVG",
    "upTo16KibScriptsLinks": "Do 16 KiB. Skrypty, linki i zewnętrzne odniesienia są usuwane; użyj currentColor w pliku, by działał kolor kolekcji.",
    "colour": "Kolor",
    "aPresetOneYouUsedRecently": "Gotowy kolor, ostatnio użyty albo własny z palety.",
    "collectionColour": "Kolor kolekcji",
    "recent": "Ostatnie",
    "useHex": "Użyj {{hex}}",
    "kindOfPage": "Rodzaj strony",
    "everyPageIsACodexEntry": "Każda strona to wpis Kodeksu jednego rodzaju; rodzaj decyduje, jak traktują go Kontrole, wzmianki @ i graf, i zachowuje jego kolor wszędzie.",
    "collectionBaseKind": "Rodzaj bazowy kolekcji",
    "magicOrShipsConceptDeitiesOr": "Magia lub Statki → Pojęcie · Bóstwa lub Domy → Postać lub Frakcja · kolekcja miasteczek → Miejsce.",
    "sharedFields": "Pola wspólne",
    "thePropertiesOfTheCollectionValues": "Właściwości kolekcji — wartości zapisuje się na każdej stronie, a strona może też dodać własne pola.",
    "collectionTemplate": "Szablon kolekcji",
    "template": "Szablon…",
    "addField": "Dodaj pole",
    "exampleMagicLevelNumberRarityChoice": "Przykład: Magia → Poziom (liczba) · Rzadkość (wybór: pospolita, rzadka, legendarna) · Zdobyta (data historii) · Nauczona przez (link do wpisu).",
    "collectionFieldNameValue": "Nazwa pola kolekcji {{value}}",
    "fieldName": "Nazwa pola",
    "collectionFieldTypeValue": "Typ pola kolekcji {{value}}",
    "collectionFieldOptionsValue": "Opcje pola kolekcji {{value}}",
    "optionsOnePerLine": "Opcje, po jednej w wierszu",
    "required": "Wymagane",
    "requiredCollectionFieldValue": "Wymagane pole kolekcji {{value}}",
    "removeCollectionFieldValue": "Usuń pole kolekcji {{value}}",
    "yesNo": "Tak / Nie",
    "multipleChoice": "Wielokrotny wybór",
    "storyDate": "Data historii",
    "entryLink": "Link do wpisu",
    "multipleEntryLinks": "Wiele linków do wpisów",
    "fieldParagraph": "Akapit",
    "fieldNumber": "Liczba",
    "fieldChoice": "Wybór"
  },
  "worldCloudPanel": {
    "worldCloudVersions": "Wersje chmurowe Świata",
    "includesCodexPagesCollectionsFoldersFacts": "Obejmuje strony Kodeksu, kolekcje, foldery, fakty, relacje i załączniki. Opublikuj lub pobierz wersję jawnie. Rękopis używa synchronizacji scen.",
    "compareVersions": "Porównaj wersje",
    "recoverPreviousWorld": "Odzyskaj poprzedni Świat…",
    "deviceRevision": "Rewizja urządzenia",
    "accountVersionRemoteversion": "Wersja konta {{remoteVersion}}",
    "firstAccountVersion": "Pierwsza wersja konta",
    "uploadDeviceVersion": "Wyślij wersję z urządzenia…",
    "useAccountVersion": "Użyj wersji konta…",
    "confirmTransfer": "Potwierdź przeniesienie",
    "replaceWorldOnThisDeviceWith": "Zastąpić Świat na tym urządzeniu tą wersją? Najpierw zostanie zachowana kopia obecnego Świata i załączników. Tekst rękopisu pozostaje bez zmian.",
    "saveThisCopyToYourAccount": "Zapisać tę kopię na koncie? Poprzednie wersje konta zostaną zachowane.",
    "restoreWorldFromBeforeTheLast": "Przywrócić Świat sprzed ostatniego przeniesienia? Późniejsze edycje uniemożliwiają to przywrócenie.",
    "confirm": "Potwierdź",
    "cancel": "Anuluj",
    "transferring": "Przenoszenie…",
    "codexPages": "Strony Kodeksu",
    "updateStoryideBeforePublishingChangesTo": "Zaktualizuj Musael przed publikowaniem zmian w tym Archiwum.",
    "theAccountVersionChangedCompareAgain": "Wersja konta się zmieniła. Porównaj ponownie przed zastosowaniem.",
    "worldChangedOnThisDeviceCompare": "Świat zmienił się na tym urządzeniu. Porównaj ponownie przed zastosowaniem.",
    "accountVersionStorageIsFullPrevious": "Magazyn wersji konta jest pełny. Poprzednie kopie są zachowane.",
    "anAttachmentFailedItsIntegrityCheck": "Załącznik nie przeszedł kontroli integralności. Żadna kopia lokalna nie została zastąpiona.",
    "theAccountCopyFailedItsIntegrity": "Kopia konta nie przeszła kontroli integralności.",
    "noRecoveryCopyIsAvailableFor": "Brak kopii odzyskiwania dla tego przeniesienia.",
    "anIdentifierIsAlreadyUsedIn": "Identyfikator jest już używany w innym projekcie.",
    "openOrSyncTheManuscriptWith": "Najpierw otwórz lub zsynchronizuj rękopis ze swoim kontem.",
    "yourAccountDoesNotHaveThe": "Twoje konto nie ma wymaganego uprawnienia.",
    "signInAgainThisSessionWas": "Zaloguj się ponownie. Ta sesja została unieważniona.",
    "transferCancelled": "Przeniesienie anulowane.",
    "transferFailedCheckYourConnectionAnd": "Przeniesienie nie powiodło się. Sprawdź połączenie i porównaj ponownie.",
    "couldNotReadTheRecoveryCopy": "Nie udało się odczytać kopii odzyskiwania.",
    "mondoPrecedenteRipristinato": "Poprzedni Świat przywrócony.",
    "accountVersionVersionSaved": "Wersja konta {{version}} zapisana.",
    "versionVersionAppliedToWorldOn": "Wersja {{version}} zastosowana do Świata na tym urządzeniu.",
    "cancellationRequested": "Zażądano anulowania.",
    "labelFacts": "Fakty",
    "labelEvents": "Wydarzenia",
    "labelKnowledge": "Wiedza",
    "labelAnnotations": "Adnotacje",
    "labelRelationships": "Relacje",
    "labelAttachments": "Załączniki",
    "labelCollections": "Kolekcje",
    "labelFolders": "Foldery",
    "changedCount_one": "Zmiany: {{count}}",
    "changedCount_few": "Zmiany: {{count}}",
    "changedCount_many": "Zmiany: {{count}}",
    "changedCount_other": "Zmiany: {{count}}"
  },
  "worldMaps": {
    "character": "Postać",
    "place": "Miejsce",
    "object": "Przedmiot",
    "faction": "Frakcja",
    "concept": "Pojęcie",
    "pinOf": "Pinezka: {{name}}",
    "pinMissing": "Pinezka brakującego wpisu",
    "missingEntry": "Brakujący wpis",
    "zoom": "Powiększenie",
    "zoomIn": "Powiększ",
    "zoomOut": "Pomniejsz",
    "fitToView": "Dopasuj do widoku",
    "newMap": "Nowa mapa",
    "newMapDescription": "Obraz miejsca, z pinezkami przy ludziach, miejscach i rzeczach, które tam są.",
    "cancel": "Anuluj",
    "saving": "Zapisywanie…",
    "createMap": "Utwórz mapę",
    "mapOf": "Mapa:",
    "aNewPlace": "Nowe miejsce",
    "placeName": "Nazwa miejsca",
    "placeNamePlaceholder": "Słony Brzeg",
    "picture": "Obraz",
    "choosePicture": "Wybierz PNG, JPEG, WebP lub GIF",
    "pictureHint": "Do 16 MB. Staje się jednym z załączników wpisu.",
    "maps": "Mapy",
    "mapsLead": "Przypinaj wpisy na obrazach swoich miejsc. Przypięte miejsce z własną mapą ją otwiera.",
    "noMapsYet": "Brak map",
    "noMapsText": "Daj miejscu obraz, potem przypnij wpisy, które do niego należą.",
    "addTheFirstMap": "Dodaj pierwszą mapę",
    "onePin": "1 pinezka",
    "pins": "Pinezki: {{count}}",
    "inPlace": "na: {{place}}",
    "chooseAnEntryOrName": "Wybierz wpis albo wpisz nazwę pinezki.",
    "mapTrail": "Mapy nadrzędne",
    "doneAdding": "Gotowe",
    "addPin": "Dodaj pinezkę",
    "labels": "Etykiety",
    "replacePicture": "Zastąp obraz",
    "removeMap": "Usuń mapę",
    "hintClick": "Kliknij mapę tam, gdzie ma być pinezka.",
    "hintChoose": "Wybierz po prawej, na co wskazuje pinezka.",
    "pictureMissing": "Obrazu tej mapy nie ma jeszcze na tym urządzeniu.",
    "pinDetails": "Szczegóły pinezki",
    "newPin": "Nowa pinezka",
    "entry": "Wpis",
    "chooseAnEntry": "Wybierz wpis",
    "noEntryLabelOnly": "Bez wpisu, tylko etykieta",
    "labelOnTheMap": "Etykieta na mapie",
    "labelDefault": "Nazwa wpisu",
    "labelRequired": "Potrzebna bez wpisu",
    "placePin": "Umieść pinezkę",
    "label": "Etykieta",
    "openEntry": "Otwórz wpis",
    "openItsMap": "Otwórz jego mapę",
    "position": "{{x}}% od lewej, {{y}}% od góry",
    "removePin": "Usuń pinezkę",
    "noPinsYet": "Brak pinezek. Użyj Dodaj pinezkę, potem kliknij mapę.",
    "shownOn": "Pokazano na",
    "openEntryOf": "Otwórz: {{name}}",
    "removeMapTitle": "Usunąć mapę: {{name}}?",
    "removeMapMessage": "Pinezki znikają razem z nią. Obraz zostaje w załącznikach wpisu."
  },
  "worldPanel": {
    "checks": "Kontrole",
    "findAndFixConsistencyIssuesIn": "Fakty, wydarzenia i relacje Twojego świata porównane z rękopisem. Bez AI.",
    "running": "Trwa…",
    "runChecks": "Uruchom kontrole",
    "lastRunAt": "Ostatnie uruchomienie o {{time}}",
    "oneAtATime": "Po jednym naraz",
    "exclusiveRelation": "Relacja wyłączna",
    "noRelationIsExclusive": "Żadna relacja nie jest wyłączna",
    "exclusivityType": "Typ wyłączności",
    "oneSourcePerTarget": "Jedno źródło dla każdego celu",
    "oneTargetPerSource": "Jeden cel dla każdego źródła",
    "oneAtATimeHint": "Relacja, która może dotyczyć tylko jednej strony naraz, jak „posiada”: dwóch właścicieli tej samej rzeczy w tych samych momentach staje się konfliktem.",
    "rulesNeedRelations": "Reguły używają Twoich relacji. Dodaj jedną w Powiązaniach, jak „posiada”, potem uczyń ją wyłączną tutaj.",
    "results": "Wyniki",
    "whatTheChecksLookFor": "Czego szukają kontrole",
    "twoHoldersAtOnce": "Dwóch posiadaczy naraz",
    "eventsOutOfOrder": "Wydarzenia poza kolejnością",
    "quotedPastItsLimit": "Zacytowane po limicie",
    "linksToDeletedEntries": "Linki do usuniętych wpisów",
    "notesThatLostTheirPlace": "Notatki, które straciły miejsce",
    "relationsOverTime": "Relacje w czasie",
    "scopeOwnership": "Jedna rzecz posiadana przez dwa wpisy w tych samych momentach, na podstawie potwierdzonych faktów.",
    "scopeFlashback": "Wydarzenie czytane po takim, które dzieje się później w świecie: retrospekcja albo pomyłka.",
    "scopeReveal": "Fakt zacytowany w scenie po ostatniej, jaką dla niego przewidziano.",
    "scopeOrphans": "Notatki i fakty wskazujące wpis lub kartę Biblioteki, które już nie istnieją.",
    "scopeAnchors": "Zacytowany fragment, którego słowa przesunęły się lub zmieniły w jego scenie.",
    "scopeRelations": "Relacje względem reguły powyżej i względem cytatów, które przywołują.",
    "filterResults": "Filtruj wyniki",
    "all": "Wszystkie",
    "conflicts": "Konflikty",
    "warnings": "Ostrzeżenia",
    "needsData": "Potrzebne dane",
    "noIssuesFound": "Nie znaleziono problemów",
    "theExecutedRulesFoundNoViolation": "Nic nie łamie ustalonych faktów i reguł. Kontrole znają tylko to, co zostało zapisane.",
    "notEnoughData": "Za mało danych",
    "quotesInTheText": "Cytaty w tekście",
    "anchorInPlace": "Na miejscu",
    "anchorMoved": "Przesunięte",
    "anchorGone": "Zniknęło",
    "reAnchor": "Zakotwicz ponownie",
    "openScene": "Otwórz scenę",
    "checkedAt": "Sprawdzono o {{time}}.",
    "twoHold": "{{a}} i {{b}} oboje posiadają „{{object}}” w tym samym czasie.",
    "heldTwice": "{{a}} posiada „{{object}}” dwa razy w tych samych momentach.",
    "flashbackSentence": "„{{earlier}}” dzieje się przed „{{later}}” w świecie, ale jest czytane po nim: to retrospekcja, o ile jest zamierzona.",
    "revealSentence": "„{{fact}}” jest zacytowane w: {{scene}}, po ostatniej scenie, jaką dla niego przewidziano.",
    "allowedUpToScene": "Dozwolone do sceny {{scene}}",
    "orphanFactSentence": "Fakt („{{fact}}”) dotyczy wpisu, który został usunięty.",
    "orphanNoteSentence": "Notatka do „{{excerpt}}” wskazuje usunięty wpis.",
    "orphanConceptSentence": "Notatka do „{{excerpt}}” wskazuje kartę Biblioteki, która już nie istnieje.",
    "movedSentence": "„{{excerpt}}” przesunęło się w: {{scene}}: zakotwicz notatkę ponownie, aby za nim podążała.",
    "eventWithoutTime": "„{{title}}” nie ma czasu w świecie, więc jego kolejności nie da się sprawdzić.",
    "factWithoutTime": "„{{fact}}” nie ma przedziału czasu, więc jego posiadacza nie da się sprawdzić.",
    "recordWithoutTime": "Zapis nie ma czasu, więc nie da się go sprawdzić.",
    "aDeletedEntry": "usunięty wpis",
    "aDeletedEvent": "usunięte wydarzenie",
    "aScene": "scena",
    "fromTo": "Od {{start}} do {{end}}",
    "relativeToAnEvent": "Względem wydarzenia",
    "timeNotSet": "Nieustawione",
    "facts": "Fakty",
    "factsLead": "To, co ustalasz o każdym wpisie. Kontrole czytają te fakty, które potwierdzisz, i porównują je z rękopisem.",
    "entries": "Wpisy",
    "addAnEntry": "Dodaj wpis",
    "addTheFirstEntry": "Dodaj pierwszy wpis",
    "newEntityName": "Nazwa nowej encji",
    "entityType": "Typ encji",
    "addEntity": "Dodaj encję",
    "character": "Postać",
    "place": "Miejsce",
    "object": "Przedmiot",
    "faction": "Frakcja",
    "other": "Inne",
    "deleteEntityReferencesBecomeOrphaned": "Usuń encję (odniesienia stają się osierocone)",
    "deleteEntityName": "Usuń encję: {{name}}",
    "noFactYet": "Brak faktu o: {{name}}. Nowy fakt zaczyna jako proponowany; potwierdź go, aby się liczył.",
    "proposed": "Proponowany",
    "confirmed": "Potwierdzony",
    "rejected": "Odrzucony",
    "superseded": "Zastąpiony",
    "worldFact": "Fakt świata",
    "characterBelief": "Przekonanie",
    "testimony": "Zeznanie",
    "authorHypothesis": "Hipoteza",
    "confirm": "Potwierdź",
    "confirmExplicitApproval": "Potwierdź (jawna akceptacja)",
    "newFactAbout": "Nowy fakt o: {{name}}",
    "predicatePlaceholder": "posiada",
    "predicate": "Orzeczenie",
    "valuePlaceholder": "miecz",
    "value": "Wartość",
    "kind": "Rodzaj",
    "epistemicKind": "Rodzaj epistemiczny",
    "kindHint": "Za prawdę liczą się tylko fakty świata; przekonania, zeznania i hipotezy są zachowane, ale nie sprawdzane jako kanon.",
    "when": "Kiedy",
    "timeKind": "Rodzaj czasu",
    "betweenTwoMoments": "Między dwoma momentami",
    "from": "Od",
    "to": "do",
    "startTick": "Takt początkowy",
    "endTick": "Takt końcowy",
    "momentsHint": "Momenty na osi czasu świata; koniec nie jest wliczony.",
    "reveal": "Ujawnienie",
    "maximumRevealNarrativeIndex": "Maksymalne ujawnienie (indeks narracyjny)",
    "noLimit": "Bez limitu",
    "sceneNumbered": "{{n}}. {{title}}",
    "revealHint": "Cytaty tego faktu w późniejszej scenie są oznaczane.",
    "addFactProposed": "Dodaj jako proponowany",
    "selectAnEntityToSeeAnd": "Wybierz wpis, aby zobaczyć i dodać jego fakty.",
    "noEntityYet": "Brak wpisów. Dodaj postać, miejsce lub przedmiot powyżej albo w Kodeksie.",
    "resultDetails": "Szczegóły wyniku",
    "conflict": "Konflikt",
    "warning": "Ostrzeżenie",
    "whatWasCompared": "Co porównano",
    "whatToDo": "Co zrobić",
    "comparedOwnership": "Potwierdzone fakty świata z przedziałem czasu. Dwóch posiadaczy tej samej rzeczy nie może się nakładać.",
    "comparedFlashback": "Czas każdego wydarzenia w świecie względem kolejności jego sceny w książce.",
    "comparedReveal": "Ostatnia scena, jaką przewidziano dla faktu, względem scen, które go cytują.",
    "comparedOrphans": "Każda notatka i fakt względem istniejących wpisów i kart Biblioteki.",
    "comparedAnchors": "Cytat każdej notatki względem obecnego tekstu sceny.",
    "confirmOnlyOneOwnerInThe": "Zostaw jednego posiadacza dla tych momentów: zawęź jeden z przedziałów czasu albo cofnij jeden fakt do proponowanego.",
    "ifTheSceneIsADeliberate": "Jeśli scena jest zamierzoną retrospekcją, zostaw ją. W przeciwnym razie przenieś scenę albo zmień czas wydarzenia.",
    "raiseTheMaximumRevealSceneOf": "Dopuść późniejszą scenę dla faktu albo przenieś cytat wcześniej.",
    "restoreTheMissingEntityFromThe": "Przywróć wpis z historii Kodeksu albo usuń notatkę lub fakt, który na niego wskazuje.",
    "useReAnchorManualOnThe": "Użyj Zakotwicz ponownie na cytacie w wynikach albo otwórz scenę i zaznacz fragment ponownie.",
    "giveTheEventOrFactAn": "Nadaj mu czas w świecie albo zostaw go bez czasu: kontrola milczy zamiast zgadywać.",
    "selectAResult": "Wybierz wynik",
    "detailsConstraintsAndSuggestedFixesAppear": "Tutaj pojawi się to, co porównano, i to, co należy zrobić.",
    "thisAnnotationCannotBeReAnchored": "Tej notatki nie da się zakotwiczyć ponownie: „{{excerpt}}” brakuje lub występuje w scenie więcej niż raz.",
    "revisionTools": "Narzędzia rewizji",
    "loadingRevisionTools": "Wczytywanie narzędzi rewizji…"
  },
  "worldReplicationPanel": {
    "theContentChangedWhileItWas": "Treść zmieniła się podczas potwierdzania. Wybierz treść i akceptację, które zostały sprawdzone.",
    "theseChangesCannotBeCombinedInto": "Tych zmian nie da się połączyć w poprawny Świat. Wybierz pełną wersję do zachowania; obie kopie zostają w odzyskiwaniu.",
    "thisDevice": "To urządzenie",
    "yourAccount": "Twoje konto",
    "viewWorld": "Zobacz Świat",
    "previousSharedValue": "Poprzednia wartość wspólna",
    "theActionCouldNotFinishYour": "Działanie nie zakończyło się. Twoje lokalne zmiany są zachowane.",
    "worldSync": "Synchronizacja Świata",
    "syncCodexPagesFactsTimelinesCollections": "Synchronizuj strony Kodeksu, fakty, osie czasu, kolekcje i załączniki między urządzeniami. Notatki i szkice synchronizują się osobno, poniżej.",
    "syncWorldAutomatically": "Synchronizuj Świat automatycznie",
    "n1PendingChange": "1 oczekująca zmiana",
    "pendingPendingChanges": "Oczekujące zmiany: {{pending}}",
    "syncNow": "Synchronizuj teraz",
    "exportRecoveryCopies": "Eksportuj kopie odzyskiwania",
    "compareBeforeSyncing": "Porównaj przed synchronizacją",
    "signInToTheLinkedAccount": "Zaloguj się na połączone konto, aby synchronizować. Zmiany lokalne pozostają zapisane.",
    "signInToCompareYourWorld": "Zaloguj się, aby porównać swój Świat i włączyć synchronizację.",
    "chooseYourStartingWorld": "Wybierz swój Świat wyjściowy",
    "bothCopiesHaveTheSameContent": "Obie kopie mają tę samą treść.",
    "keepTheWorldOnThisDevice": "Zachowaj Świat na tym urządzeniu albo użyj kopii na koncie. Poprzedni lokalny Świat i załączniki zostają w odzyskiwaniu.",
    "keepThisDeviceSync": "Zachowaj to urządzenie i synchronizuj",
    "useAccountCopySync": "Użyj kopii konta i synchronizuj",
    "cancel": "Anuluj",
    "reviewConcurrentChanges": "Przejrzyj równoległe zmiany",
    "chooseEachValueToKeepOther": "Wybierz każdą wartość do zachowania. Pozostałe zmiany łączą się automatycznie. Obie wersje pozostają do odzyskania.",
    "applyReviewedChoices": "Zastosuj przejrzane wybory",
    "syncingWorldAndAttachments": "Synchronizacja Świata i załączników…",
    "codexPages": "Strony Kodeksu",
    "onThisDevice": "Na tym urządzeniu",
    "waitingToSync": "Oczekuje na synchronizację",
    "syncing": "Synchronizacja…",
    "upToDate": "Aktualne",
    "reviewNeeded": "Potrzebny przegląd",
    "emptyText": "(pusty tekst)",
    "emptyList": "(pusta lista)",
    "worldStructure": "Struktura Świata",
    "labelFacts": "Fakty",
    "labelEvents": "Wydarzenia",
    "labelKnowledge": "Wiedza",
    "labelAnnotations": "Adnotacje",
    "labelRelationships": "Relacje",
    "labelAttachments": "Załączniki",
    "labelCollections": "Kolekcje",
    "labelFolders": "Foldery",
    "paused": "Wstrzymano",
    "addedCount_one": "Dodano: {{count}}",
    "addedCount_few": "Dodano: {{count}}",
    "addedCount_many": "Dodano: {{count}}",
    "addedCount_other": "Dodano: {{count}}",
    "removedCount_one": "Usunięto: {{count}}",
    "removedCount_few": "Usunięto: {{count}}",
    "removedCount_many": "Usunięto: {{count}}",
    "removedCount_other": "Usunięto: {{count}}",
    "changedCount_one": "Zmieniono: {{count}}",
    "changedCount_few": "Zmieniono: {{count}}",
    "changedCount_many": "Zmieniono: {{count}}",
    "changedCount_other": "Zmieniono: {{count}}",
    "removedValue": "Usunięte",
    "emptyValue": "Puste"
  },
  "worldReviewTools": {
    "deletedEntry": "Usunięty wpis",
    "timeUnknown": "Czas nieznany",
    "storyTimeInterval": "Przedział w czasie historii",
    "relativeToEventPreserved": "Względem wydarzenia (zachowane)",
    "from": "Od",
    "until": "Do",
    "characterKnowledge": "Wiedza postaci",
    "couldNotCheckTheSavedManuscriptRetry": "Nie udało się sprawdzić zapisanego rękopisu. Spróbuj ponownie.",
    "revisionTools": "Narzędzia rewizji",
    "changeImpact": "Wpływ zmiany",
    "whatPointsToThisRecord": "Co wskazuje na ten zapis?",
    "explicitLinksOnlyIncludingIndirectLinksChangingARecord": "Tylko jawne linki, także pośrednie. Zmiana zapisu nie przepisuje tych, które od niego zależą.",
    "impactRecord": "Zapis do analizy",
    "chooseARecord": "Wybierz zapis",
    "linkedRecordsWorldRevision": "powiązanych zapisów · rewizja Świata",
    "directLink": "Bezpośredni link",
    "missingSourceScene": "Brakująca scena źródłowa",
    "noExplicitRecordLinksToThisEntryUnlinkedProse": "Żaden zapis nie wskazuje jawnie na ten wpis. Niepowiązana proza jest poza tą kontrolą.",
    "whenDidTheyLearnIt": "Kiedy postać się o tym dowiedziała?",
    "recordAcquisitionAndUseOnTheSameStoryTime": "Zapisz zdobycie i użycie na tej samej osi czasu historii. Domysły i przekonania zostają osobno; kolejność rozdziałów nigdy nie jest traktowana jako czas historii.",
    "recordKnowledge": "Zapisz wiedzę",
    "couldNotSaveCheckTheIntervalsOrCancelAnd": "Nie udało się zapisać. Sprawdź przedziały albo anuluj i otwórz ponownie, jeśli Świat się zmienił.",
    "character": "Postać",
    "knowledgeCharacter": "Postać wiedzy",
    "chooseACharacter": "Wybierz postać",
    "fact": "Fakt",
    "knowledgeFact": "Fakt wiedzy",
    "chooseAConfirmedWorldFact": "Wybierz potwierdzony fakt świata",
    "acquired": "Zdobyte",
    "acquisitionSource": "Źródło zdobycia",
    "noSourceAttached": "Brak dołączonego źródła",
    "use": "Użycie",
    "scene": "Scena",
    "chooseAScene": "Wybierz scenę",
    "knownInformation": "Znana informacja",
    "belief": "Przekonanie",
    "guess": "Domysł",
    "passageSource": "Źródło fragmentu",
    "noPassageAttached": "Brak dołączonego fragmentu",
    "removeUse": "Usuń użycie",
    "addUse": "Dodaj użycie",
    "confirmAndSave": "Potwierdź i zapisz",
    "cancel": "Anuluj",
    "missingFact": "Brakujący fakt",
    "atUnknownRelativeTime": "w nieznanym/względnym czasie",
    "edit": "Edytuj",
    "couldNotRemoveTheRecordRefreshAndRetry": "Nie udało się usunąć zapisu. Odśwież i spróbuj ponownie.",
    "checkSavedKnowledge": "Sprawdź zapisaną wiedzę",
    "theWorldChangedSinceThisResultRunTheCheck": "Świat zmienił się po tym wyniku. Uruchom kontrolę ponownie.",
    "recordedUseIsEarlierThanAcquisition": "Zapisane użycie jest wcześniejsze niż zdobycie",
    "recordedTimesAreInOrder": "Zapisane czasy są w kolejności",
    "beliefOrGuessNotAKnowledgeConflict": "Przekonanie lub domysł — nie konflikt wiedzy",
    "notEnoughInformationToCompare": "Za mało informacji do porównania",
    "attachedPassagesMatchTheSavedText": "Dołączone fragmenty zgadzają się z zapisanym tekstem",
    "aSourceIsMissingStaleOrBelongsToAnother": "Brakuje źródła albo jest ono nieaktualne lub należy do innej sceny",
    "authorRecordedTimesPassagesAreNotVerified": "Czasy zapisane przez autora; fragmenty nie są weryfikowane",
    "openScene": "Otwórz scenę",
    "noConfirmedKnowledgeUsesToCompare": "Brak potwierdzonych użyć wiedzy do porównania.",
    "openNamedScene": "Otwórz: {{title}}",
    "recordSummary": "Użycia: {{count}} · {{lifecycle}} · Zdobyte {{time}}",
    "checkSummary": "Sprawdzono o {{time}} · zapisane użycia: {{count}}. Odśwież po edycji prozy.",
    "resultsLimitedTo500Records": "Wyniki ograniczone do 500 rekordów",
    "linksAway": "Odległość w powiązaniach: {{depth}}",
    "useNKind": "Rodzaj użycia {{n}}",
    "useN": "Użycie {{n}}",
    "useNSource": "Źródło użycia {{n}}",
    "checking": "Sprawdzanie…"
  },
  "worldSection": {
    "overview": "Przegląd",
    "vault": "Archiwum",
    "timeline": "Oś czasu",
    "connections": "Powiązania",
    "references": "Odniesienia",
    "checks": "Kontrole",
    "analysis": "Analiza",
    "characters": "Postacie",
    "locations": "Miejsca",
    "factions": "Frakcje",
    "objects": "Przedmioty",
    "concepts": "Pojęcia",
    "worldViews": "Widoki świata",
    "world": "Świat",
    "browseByType": "Przeglądaj według typu",
    "filterByType": "Filtruj według typu",
    "all": "Wszystkie",
    "newEntry": "Nowy wpis",
    "cercaNelCodex": "Przeszukaj Kodeks",
    "searchEntries": "Szukaj wpisów…",
    "entry": "wpis",
    "entries": "wpisy",
    "alsoAliases": "Także: {{aliases}}",
    "noEntriesYetCreateTheFirst": "Brak wpisów. Utwórz pierwszą postać, miejsce lub frakcję.",
    "noEntryMatches": "Żaden wpis nie pasuje.",
    "editName": "Edytuj: {{name}}",
    "edit": "Edytuj",
    "archive": "Archiwizuj",
    "confirmArchive": "Potwierdź archiwizację",
    "notesAndSketches": "Notatki i szkice",
    "alsoKnownAs": "Znany też jako",
    "addADescriptionOneLineThat": "Dodaj opis — jedną linijkę mówiącą, czym to jest.",
    "none": "Brak",
    "yes": "Tak",
    "no": "Nie",
    "removedEntry": "Usunięty wpis",
    "unavailableEntry": "Niedostępny wpis",
    "noNotesYetEditTheEntry": "Brak notatek. Edytuj wpis, aby go opisać.",
    "linkedScenes": "Powiązane sceny",
    "showTheEntriesOfABook": "Pokaż wpisy książki",
    "allBooks": "Wszystkie książki",
    "bookLine": "Tom {{number}} · {{title}}",
    "inNoBookYet": "Jeszcze w żadnej książce",
    "scenesThatMentionThisEntryBy": "Sceny wspominające ten wpis po nazwie lub aliasie pojawiają się tutaj.",
    "facts": "Fakty",
    "noFactRecordedFactsAreAdded": "Brak zapisanych faktów. Fakty dodaje się i zatwierdza w Kontrolach.",
    "relations": "Relacje",
    "noRelationYet": "Brak relacji.",
    "proposed": " · proponowana",
    "viewAll": "Zobacz wszystkie",
    "attachments": "Załączniki",
    "attachAnImageToUseIt": "Dołącz obraz, aby użyć go jako portretu.",
    "kib": "KiB",
    "open": "Otwórz",
    "remove": "Usuń",
    "addAttachment": "Dodaj załącznik",
    "stateAtStoryTime": "Stan w czasie historii",
    "tick": "Takt",
    "factsWithoutACompleteInterval": "faktów bez pełnego przedziału.",
    "selectAnEntry": "Wybierz wpis",
    "charactersPlacesFactionsAndObjectsLive": "Tutaj żyją postacie, miejsca, frakcje i przedmioty, z ich faktami, relacjami i załącznikami.",
    "recentChanges": "Ostatnie zmiany",
    "undoChange": "Cofnij zmianę",
    "worldTimeline": "Oś czasu Świata",
    "eventsPeopleAndPlacesInA": "Wydarzenia, ludzie i miejsca w szerszym kontekście.",
    "noEventYet": "Brak wydarzeń",
    "addTheFirstEventWithA": "Dodaj pierwsze wydarzenie z czasem historii albo zostaw czas nieznany, dopóki go nie poznasz.",
    "tick2": "takt",
    "plotEvent": "Wydarzenie fabularne",
    "worldEvent": "Wydarzenie świata",
    "openScene": "Otwórz scenę",
    "unknownTime": "Czas nieznany",
    "unknown": "nieznany",
    "seeHowYourWorldSPeople": "Zobacz, jak są ze sobą połączeni ludzie, miejsca i idee Twojego świata.",
    "connectionsView": "Widok powiązań",
    "graph": "Graf",
    "list": "Lista",
    "nothingToConnectYet": "Nie ma jeszcze czego łączyć",
    "createEntriesInTheCodexAnd": "Utwórz wpisy w Kodeksie i powiąż je w widoku Listy.",
    "selectedEntry": "Zaznaczony wpis",
    "relationSummary": "Podsumowanie relacji",
    "noSceneMentionsThisEntryYet": "Żadna scena jeszcze nie wspomina tego wpisu.",
    "openInCodex": "Otwórz w Kodeksie",
    "selectANodeToSeeIts": "Zaznacz węzeł, aby zobaczyć jego relacje i sceny.",
    "annotationsAnchoredInTheManuscriptAnd": "Adnotacje zakotwiczone w rękopisie i pliki, które trzymasz dla swojego świata.",
    "addFile": "Dodaj plik",
    "annotations": "Adnotacje",
    "selectTextInTheManuscriptAnd": "Zaznacz tekst w rękopisie i użyj „Adnotuj”, aby zakotwiczyć urządzenie, encję lub notatkę.",
    "scene": "Scena",
    "device": "Urządzenie",
    "entity": "Encja",
    "note": "Notatka",
    "imagesPdfsNotesAndAudioYou": "Obrazy, PDF-y, notatki i dźwięki, które dołączasz do świata lub wpisu.",
    "linked": "Powiązane",
    "orphan": "Osierocone",
    "openFile": "Otwórz plik",
    "referenceDetails": "Szczegóły odniesienia",
    "textAnnotation": "Adnotacja tekstowa",
    "kind": "Rodzaj",
    "anchor": "Kotwica",
    "concept": "Pojęcie",
    "created": "Utworzono",
    "anchorStatesValidStaleOrphanedAnd": "Stany kotwic (ważna, nieaktualna, osierocona) i ponowne kotwiczenie liczy się w Kontrolach.",
    "attachment": "Załącznik",
    "type": "Typ",
    "size": "Rozmiar",
    "linkedTo": "Powiązane z",
    "added": "Dodano",
    "confirmRemove": "Potwierdź usunięcie",
    "selectAnAnnotationOrAFile": "Zaznacz adnotację lub plik.",
    "exploreTheShapeOfYourStory": "Zbadaj kształt swojej historii: długość, obecność i gęstość w scenach.",
    "sceneLength": "Długość scen",
    "wordsPerScene": "Słowa na scenę",
    "noScenesYet": "Brak scen.",
    "titleFmtWords": "{{title}}: liczba słów {{fmt}}",
    "entityDensity": "Gęstość encji",
    "codexMentionsPerScene": "Wzmianki Kodeksu na scenę",
    "titleMentionsMentions": "{{title}}: liczba wzmianek {{mentions}}",
    "characterAppearanceMap": "Mapa występowania postaci",
    "aDotWhereACharacterIs": "Punkt oznacza scenę, w której pada nazwa postaci",
    "addCharactersToTheCodexAnd": "Dodaj postacie do Kodeksu i nazwij je w scenach.",
    "thisScene": "Ta scena",
    "words": "Słowa",
    "paragraphs": "Akapity",
    "sentencesEst": "Zdania (szac.)",
    "distinctWords": "Różne słowa",
    "annotatedDevices": "Oznaczone urządzenia",
    "n1000Words": "/ 1000 słów",
    "repetitions": "Powtórzenia",
    "exportHtml": "Eksportuj HTML",
    "exportTxt": "Eksportuj TXT",
    "events": "Wydarzenia",
    "confirmedFacts": "Potwierdzone fakty",
    "recentlyChanged": "Ostatnio zmienione",
    "changesToTheWorldWillBe": "Zmiany w świecie będą wymienione tutaj, każda z cofnięciem.",
    "undo": "Cofnij",
    "startHere": "Zacznij tutaj",
    "overviewEmptyLead": "Ludzie, miejsca i wydarzenia Twojej historii, powiązane ze scenami, w których występują.",
    "addACharacter": "Dodaj postać",
    "addACharacterText": "Kim jest postać, czego chce i co stoi jej na drodze.",
    "addAPlace": "Dodaj miejsce",
    "addAPlaceText": "Gdzie dzieją się sceny: miasto, statek, jeden pokój.",
    "addAnEventText": "Coś, co dzieje się w historii, z datą albo bez.",
    "inThisWorld": "W tym świecie",
    "createAnEntry": "Utwórz wpis",
    "aCharacterAPlaceAFaction": "Postać, miejsce, frakcja, przedmiot lub pojęcie.",
    "addAnEvent": "Dodaj wydarzenie",
    "withAnExactStoryTimeOr": "Z dokładnym czasem historii albo nieznanym.",
    "runTheChecks": "Uruchom kontrole",
    "deterministicRulesOwnershipOrderAnchorsOrphans": "Właściciele, kolejność, ujawnienia i relacje w czasie, porównane z tekstem.",
    "loadingTheWorld": "Wczytywanie świata…",
    "maps": "Mapy",
    "openItsMap": "Otwórz jego mapę",
    "addAMap": "Dodaj mapę",
    "pinnedOn": "Przypięto na",
    "typeCharacter": "Postać",
    "typeLocation": "Miejsce",
    "typeObject": "Przedmiot",
    "typeFaction": "Frakcja",
    "typeConcept": "Pojęcie",
    "annotationsToReAnchor_one": "{{count}} adnotacja do ponownego zakotwiczenia.",
    "annotationsToReAnchor_few": "{{count}} adnotacje do ponownego zakotwiczenia.",
    "annotationsToReAnchor_many": "{{count}} adnotacji do ponownego zakotwiczenia.",
    "annotationsToReAnchor_other": "{{count}} adnotacji do ponownego zakotwiczenia."
  }
}
